<template>
  <div v-if="showModal" class="fixed inset-0 flex items-center justify-center bg-black/80 z-[999] px-4 backdrop-blur-sm">
    <div class="relative w-[90%] max-w-[420px] bg-[#14181F] border border-gray-800 p-8 rounded-[16px] shadow-[0_10px_40px_rgba(0,0,0,0.5)] text-center font-sans">
      
      <!-- Close Button -->
      <button
        @click="$emit('close')"
        class="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-white/5 hover:bg-white/10 text-white/50 hover:text-white transition-colors"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <!-- Icon -->
      <div class="mb-4 inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-500/10 text-red-500">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      </div>

      <!-- Title -->
      <h2 class="text-2xl sm:text-3xl font-black text-[#00F0FF] font-oxanium tracking-wide uppercase mb-4 mt-2">
        {{ $t('ProfileLockModal.Title') }}
      </h2>

      <!-- Description -->
      <p class="text-[#B9CACB] text-sm sm:text-base leading-relaxed mb-6">
        {{ $t('ProfileLockModal.Message') }}
        <span class="font-bold text-white text-lg">{{ daysLeft }}</span> {{ $t('ProfileLockModal.Days') }}
      </p>

      <!-- OK Button -->
      <div class="flex w-full">
        <button
          @click="$emit('close')"
          class="w-full px-6 py-3 bg-[#00F0FF] text-black font-bold text-sm rounded-[10px] hover:bg-[#00d4e0] transition-colors uppercase tracking-wider"
        >
          {{ $t('ProfileLockModal.Close') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
    daysLeft: Number,
  },
};
</script>

  <style scoped>
  .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  </style>
  